import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { CloudService } from "../cloud.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  constraints = {
    video: { facingMode: { ideal: "environment" } },
    audio: false
  };

  public text: any | undefined;

  @ViewChild("video", { static: true })
  public video: ElementRef;

  @ViewChild("canvas", { static: true })
  public canvas: ElementRef;

  public captures: Array<any>;

  constructor(public cs: CloudService) {
    this.captures = [];
  }

  public ngOnInit() {}

  public ngAfterViewInit() {
    // console.log(navigator.mediaDevices.getSupportedConstraints());
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia(this.constraints).then(stream => {
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
      });
    }
  }

  public capture() {
    var context = this.canvas.nativeElement
      .getContext("2d")
      .drawImage(this.video.nativeElement, 0, 0, 640, 480);
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));

    let imageName = "Webapp_1.jpg";
    const imageBlob = this.dataURItoBlob(
      this.canvas.nativeElement.toDataURL("image/png")
    );
    const imageFile = new File([imageBlob], imageName, { type: "image/jpeg" });
    // NOTE: we're automatically uploading to the database, we probably shouldn't do that.
    this.cs.upload(imageFile);
  }

  getText(): any {
    return this.cs.getText();
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });
    return blob;
  }

  public analyze() {
    this.cs.callExtractText(this.cs.imagePath);
  }
}
